export default class Palette {

    static PRIMARY = "#a52620"
    static SECONDARY = "#0F4C82"
    static DARK_GREY = '#28545c'
    static NARA_GREEN = '#389290'

    // static PRIMARY = "#a52620"
}
